import label from "@/lang/StaticLabels.js";

// PSCMS Router  - تدارکات و خرید   -----------------------------------------------
let routeItems = {
  path: "PSCMS",
  name: "PSCMS",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  // با کلیک روی ماژول، داشبورد همان ماژول پیش‌فرض باز می‌شود
  redirect: { name: "PSCMSDashboard" },
  children: [
    {
      path: "dashboard",
      name: "PSCMSDashboard",
      meta: {
        label: label.page.dashboard + " " + label.modules.pscms,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pscms/Dashboard"),
    },

    // Base Information -----------------------------------------------
    {
      path: "buyType",
      name: "PSCMSBuyType",
      meta: {
        label: label.page.buyType,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pscms/base/buyType"),
    },
    {
      path: "buyAddMinus",
      name: "PSCMSBuyAddMinus",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "buyAddMinus/list",
      children: [
        {
          path: "list",
          name: "PSCMSBuyAddMinusList",
          component: () => import("@/views/modules/pscms/base/buyAddMinus"),
          meta: {
            label: label.page.buyAddMinus,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PSCMSAddBuyAddMinus",
          component: () =>
            import("@/views/modules/pscms/base/buyAddMinus/Info"),
          meta: {
            label: label.page.addBuyAddMinus,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PSCMSEditBuyAddMinus",
          component: () =>
            import("@/views/modules/pscms/base/buyAddMinus/Info"),
          meta: {
            label: label.page.editBuyAddMinus,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "systemSetting",
      name: "PSCMSSystemSetting",
      meta: {
        label: label.page.scmsSetting,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pscms/base/systemSetting"),
    },

    // Operation -----------------------------------------------
    {
      path: "buyRequest",
      name: "PSCMSBuyRequest",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "buyRequest/list",
      children: [
        {
          path: "list",
          name: "PSCMSBuyRequestList",
          component: () => import("@/views/modules/pscms/operation/buyRequest"),
          meta: {
            label: label.page.buyRequest,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PSCMSAddBuyRequest",
          component: () =>
            import("@/views/modules/pscms/operation/buyRequest/Info"),
          meta: {
            label: label.page.addBuyRequest,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PSCMSEditBuyRequest",
          component: () =>
            import("@/views/modules/pscms/operation/buyRequest/Info"),
          meta: {
            label: label.page.editBuyRequest,
            requiresAuth: true,
          },
        },
        {
          path: "cartable",
          name: "PSCMSBuyRequestCartable",
          component: () =>
            import(
              "@/views/modules/pscms/operation/buyRequest/Cartable"
            ),
          meta: {
            label: label.page.buyRequestCartable,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "buyer",
      name: "PSCMSBuyer",
      meta: {
        label: label.page.buyer,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pscms/operation/buyer"),
    },
    {
      path: "buyFactor",
      name: "PSCMSBuyFactor",
      meta: {
        label: label.page.buyFactor,
        requiresAuth: true,
      },
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "list",
          name: "PSCMSBuyFactorList",
          component: () =>
            import("@/views/modules/pscms/operation/buyFactor"),
          meta: {
            label: label.page.buyFactor,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PSCMSBuyFactorAdd",
          component: () =>
            import("@/views/modules/pscms/operation/buyFactor/Info"),
          meta: {
            label: label.page.addBuyFactor,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PSCMSBuyFactorEdit",
          component: () =>
            import("@/views/modules/pscms/operation/buyFactor/Info"),
          meta: {
            label: label.page.editBuyFactor,
            requiresAuth: true,
          },
        },
        {
          path: "Cartable",
          name: "PSCMSBuyFactorConfirmCartable",
          component: () =>
            import("@/views/modules/pscms/operation/buyFactor/Cartable"),
          meta: {
            label: label.page.buyFactorConfirmCartable,
            requiresAuth: true,
          },
        },
        {
          path: "sort",
          name: "PSCMSSortBuyFactor",
          component: () =>
            import("@/views/modules/pscms/operation/buyFactor/Sort"),
          meta: {
            label: label.page.sortBuyFactor,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "returnBuyFactor",
      name: "PSCMSReturnBuyFactor",
      meta: {
        label: label.page.returnBuyFactor,
        requiresAuth: true,
      },
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "list",
          name: "PSCMSReturnBuyFactorList",
          component: () =>
            import("@/views/modules/pscms/operation/returnBuyFactor"),
          meta: {
            label: label.page.returnBuyFactor,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PSCMSReturnBuyFactorAdd",
          component: () =>
            import("@/views/modules/pscms/operation/returnBuyFactor/Info"),
          meta: {
            label: label.page.addReturnBuyFactor,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PSCMSReturnBuyFactorEdit",
          component: () =>
            import("@/views/modules/pscms/operation/returnBuyFactor/Info"),
          meta: {
            label: label.page.editReturnBuyFactor,
            requiresAuth: true,
          }, 
        },
        {
          path: "confirmCartable",
          name: "PSCMSReturnBuyFactorConfirmCartable",
          component: () =>
            import(
              "@/views/modules/pscms/operation/returnBuyFactor/Cartable"
            ),
          meta: {
            label: label.page.buyReturnConfirmCartable,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "managementCartable",
      name: "PSCMSManagementCartable",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "managementCartable/buyFactor",
      children: [
        {
          path: "buyFactor",
          name: "PSCMSManagementCartableBuyFactor",
          component: () =>
            import("@/views/modules/pscms/operation/managementCartable/Buy"),
          meta: {
            label: label.page.managementCartableBuy,
            requiresAuth: true,
          },
        },
        {
          path: "buyReturn",
          name: "PSCMSManagementCartableBuyReturn",
          component: () =>
            import(
              "@/views/modules/pscms/operation/managementCartable/BuyReturn"
            ),
          meta: {
            label: label.page.managementCartableBuyReturn,
            requiresAuth: true,
          },
        },
        {
          path: "requestBuy",
          name: "PSCMSManagementCartableRequestBuy",
          component: () =>
            import(
              "@/views/modules/pscms/operation/managementCartable/RequestBuy"
            ),
          meta: {
            label: label.page.managementCartableRequestBuy,
            requiresAuth: true,
          },
        },
      ],
    },
    // Reports -----------------------------------------------
    {
      path: "reports",
      name: "PSCMSReports",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "reports/latestBuyPrice",
      children: [
        {
          path: "latestBuyPriceCommodity",
          name: "PSCMSLatestBuyPriceOfCommodity",
          component: () =>
            import("@/views/modules/pscms/reports/latestBuyPrice"),
          meta: {
            label: label.page.latestBuyPriceOfCommodity,
            requiresAuth: true,
          },
        },
        {
          path: "comprehensive/factor",
          name: "PSCMSFactorComprehensiveReports",
          component: () =>
            import("@/views/modules/pscms/reports/comprehensiveReports/Factor"),
          meta: {
            label: label.page.factorComprehensiveReport,
            requiresAuth: true,
          },
        },
        {
          path: "comprehensive/commodity",
          name: "PSCMSCommodityComprehensiveReports",
          component: () =>
            import(
              "@/views/modules/pscms/reports/comprehensiveReports/Commodity"
            ),
          meta: {
            label: label.page.commodityComprehensiveReport,
            requiresAuth: true,
          },
        },
        {
          path: "monthlyPurchase/some",
          name: "PSCMSBuySomeCommodity",
          component: () =>
            import("@/views/modules/pscms/reports/monthlyPurchaseReports/Some"),
          meta: {
            label: label.page.buySomeCommodity,
            requiresAuth: true,
          },
        },
        {
          path: "monthlyPurchase/financial",
          name: "PSCMSBuyFinancialCommodity",
          component: () =>
            import(
              "@/views/modules/pscms/reports/monthlyPurchaseReports/Financial"
            ),
          meta: {
            label: label.page.buyFinancialCommodity,
            requiresAuth: true,
          },
        },
        {
          path: "buyReportBySuppliers",
          name: "PSCMSBuyReportBySuppliers",
          component: () => import("@/views/modules/pscms/reports/bySuppliers"),
          meta: {
            label: label.page.buyReportBySuppliers,
            requiresAuth: true,
          },
        },
      ],
    },
  ],
};

export default routeItems;
